import React from 'react';
import { 
  Plus, FileText, MoreHorizontal, Activity, Users, 
  TrendingUp, Server, Clock 
} from 'lucide-react';
import { theme } from '../../styles/theme';
import MetricWidget from './Widgets/MetricWidget';
import ActivityFeed from './Widgets/ActivityFeed';

interface DashboardProps {
  darkMode: boolean;
  userProfile: any;
}

const Dashboard: React.FC<DashboardProps> = ({ darkMode }) => {
  const widgets = [
    { 
      title: 'System Status', 
      icon: Activity, 
      value: 'Operational', 
      change: 'All systems running smoothly',
      status: 'success' as const,
      size: 'medium' as const
    },
    { 
      title: 'Active Users', 
      icon: Users, 
      value: '2,453', 
      change: '+12% from last week',
      status: 'success' as const,
      size: 'small' as const
    },
    { 
      title: 'API Requests', 
      icon: TrendingUp, 
      value: '1.2M', 
      change: '+5% from yesterday',
      status: 'success' as const,
      size: 'small' as const
    },
    { 
      title: 'Service Health', 
      icon: Server, 
      value: '4/5', 
      change: '1 service needs attention',
      status: 'warning' as const,
      size: 'small' as const
    },
    { 
      title: 'Response Time', 
      icon: Clock, 
      value: '45ms', 
      change: 'P95 latency',
      status: 'success' as const,
      size: 'small' as const
    },
  ];

  const recentActivities = [
    { id: 1, action: 'User Registration', user: 'john.doe@example.com', time: '2 minutes ago', status: 'success' },
    { id: 2, action: 'Service Deployed', service: 'Analytics Service', time: '15 minutes ago', status: 'success' },
    { id: 3, action: 'Security Alert', service: 'Auth Service', time: '1 hour ago', status: 'error' },
    { id: 4, action: 'API Key Generated', user: 'devops@hinata-pal.com', time: '3 hours ago', status: 'success' },
  ];

  return (
    <>
      {/* Quick Actions Bar */}
      <div className="mb-6 flex items-center justify-between">
        <div className="flex space-x-3">
          <button className="px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 text-white hover:opacity-90" style={{
            backgroundColor: theme.colors.primary.main,
          }}>
            <Plus className="w-4 h-4" />
            <span>New User</span>
          </button>
          <button className="px-4 py-2 rounded-lg transition-colors flex items-center space-x-2" style={{
            backgroundColor: darkMode ? theme.colors.background.darkPaper : theme.colors.background.paper,
            border: `1px solid ${darkMode ? theme.colors.border.dark : theme.colors.border.light}`,
            color: darkMode ? theme.colors.text.darkSecondary : theme.colors.text.primary,
          }}>
            <FileText className="w-4 h-4" />
            <span>Generate Report</span>
          </button>
        </div>
        <button className="p-2 rounded-lg transition-colors hover:bg-black hover:bg-opacity-5">
          <MoreHorizontal className="w-5 h-5" style={{ color: theme.colors.text.secondary }} />
        </button>
      </div>

      {/* Dashboard Widgets */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {widgets.map((widget, index) => (
          <MetricWidget 
            key={index}
            {...widget}
            darkMode={darkMode}
          />
        ))}
      </div>

      {/* Recent Activity */}
      <ActivityFeed 
        activities={recentActivities}
        darkMode={darkMode}
      />
    </>
  );
};

export default Dashboard;